import { ENV } from "../../../../utils";

export const SORT_OPTIONS = [
  { value: "recent", label: "Más recientes" },
  { value: "name", label: "Nombre (A-Z)" },
];

export function getCategoriesResponse(result) {
  const categories = result?.categories || result?.response || result;

  return Array.isArray(categories) ? categories : [];
}

export function getProductsResponse(result) {
  const response = result?.products || result?.response || result || {};

  return {
    docs: Array.isArray(response.docs) ? response.docs : [],
    totalDocs: Number(response.totalDocs) || 0,
    totalPages: Math.max(Number(response.totalPages) || 1, 1),
    page: Number(response.page) || 1,
    limit: Number(response.limit) || 12,
    hiddenOutOfStockCount: Number(result?.hiddenOutOfStockCount) || 0,
  };
}

export function getFiltersResponse(result) {
  const filters = result?.filters || result?.response || result || {};

  return {
    colors: Array.isArray(filters.colors)
      ? filters.colors
          .filter((color) => color && color.key)
          .map((color) => ({
            key: String(color.key),
            label: String(color.label || color.key),
            swatch: String(color.swatch || "#cccccc"),
          }))
      : [],
    brands: Array.isArray(filters.brands)
      ? filters.brands
          .filter((brand) => brand && brand.id)
          .map((brand) => ({
            id: String(brand.id),
            name: String(brand.name || ""),
          }))
      : [],
  };
}

export function getProductColors(product) {
  const colors = Array.isArray(product?.colors) ? product.colors : [];

  return colors
    .filter((color) => color?.value)
    .map((color) => ({
      value: String(color.value),
      label: String(color.label || color.value),
    }));
}

export function getImageUrl(imagePath) {
  if (!imagePath) {
    return "";
  }

  const value = String(imagePath);

  if (
    value.startsWith("http://") ||
    value.startsWith("https://") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  return `${ENV.SERVER_HOST}/${value.replace(/\\/g, "/").replace(/^\/+/, "")}`;
}

export function toggleValue(list, value) {
  return list.includes(value)
    ? list.filter((item) => item !== value)
    : [...list, value];
}
